import { VehicleSearchParams } from 'interface';

export const SEARCHQUERY = (searchParams: VehicleSearchParams) => {
  const optionsSelectedQueryParam =
    searchParams.optionsSelected && searchParams.optionsSelected.length > 0
      ? `&optionsSelected=${searchParams.optionsSelected
          .map((param) => param)
          .join(',')}`
      : '';
  const optionsAddedQueryParam = searchParams.optionsAdded
    ? `&optionsAdded=${searchParams.optionsAdded}`
    : '';
  const includeMaintenanceQueryParam = searchParams.include_maintenance
    ? `,include_maintenance=${searchParams.include_maintenance}`
    : '';
  return `id=${searchParams.id}&calculationParameters=duration=${searchParams.duration},yearly_mileage=${searchParams.yearly_mileage},initial_payment=${searchParams.initial_payment}${includeMaintenanceQueryParam}${optionsSelectedQueryParam}${optionsAddedQueryParam}`;
};
